module.exports = __webpack_public_path__ + "img/Miami Times.ded9d273.png";